<template>
  <div
    class="d-flex-column justify-start align-start gap-20"
    style="margin-top: 12px"
  >
    <h4 class="t-white font-family-1 title-h5 f-w-600">
      {{ $t("calculators_common.best_selling_badges") }}
    </h4>

    <div class="champions_box d-flex-column justify-start align-start">
      <div class="champion_grid_container badges" style="margin-top: 10px">
        <button
          class="champ_button"
          v-for="gameHero in bestSellingBadges"
          :key="gameHero.id"
          @click="() => selectBadge(gameHero.slab)"
          :class="[isSelected(gameHero.slab) && 'selected']"
        >
          <div class="badge_image_container">
            <img
              :src="gameHero.icon"
              class="champion_img"
              alt="Champion image"
              loading="lazy"
            />
          </div>
          <h4 class="t-white medium-s font-family-2">
            {{ gameHero.title }}
          </h4>
          <p class="regular-m t-grey font-family-2">${{ gameHero.price }}</p>
        </button>
      </div>
    </div>

    <h4 class="t-white font-family-1 title-h5 f-w-600">
      {{ $t("calculators_common.badges") }}
    </h4>

    <div class="champions_box d-flex-column justify-start align-start">
      <div class="champion_grid_container badges2" style="margin-top: 10px">
        <button
          class="champ_button"
          v-for="gameHero in normalSellingBadges"
          :key="gameHero.id"
          @click="() => selectBadge(gameHero.slab)"
          :class="[isSelected(gameHero.slab) && 'selected']"
        >
          <div class="badge_image_container">
            <img
              :src="gameHero.icon"
              class="champion_img"
              alt="Champion image"
              loading="lazy"
            />
          </div>
          <h4 class="t-white medium-s font-family-2">
            {{ gameHero.title }}
          </h4>
          <p class="regular-m t-grey font-family-2">${{ gameHero.price }}</p>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import SearchOutlinedIcon from "../../../icons/SearchOutlinedIcon.vue";
export default {
  data() {
    return {
      searchQuery: "",
    };
  },

  components: {
    SearchOutlinedIcon,
  },
  computed: {
    bestSellingBadges() {
      return this.getGamePack?.prices?.filter(
        (price) => price.description === "bestSelling"
      );
    },
    normalSellingBadges() {
      return this.getGamePack?.prices?.filter(
        (price) => price.description !== "bestSelling"
      );
    },
  },

  methods: {
    selectBadge(badgeId) {
      this.checkoutStore.setBadges({
        badgeId,
      });
    },
    isSelected(champion) {
      return this.checkoutStore.getSelectedBadges.includes(champion);
    },
  },

  setup() {
    const { getGamePack } = useGameStore();
    const checkoutStore = useCheckoutStore();
    return {
      getGamePack,
      checkoutStore,
    };
  },
};
</script>
